var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapseArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#006DC9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1452 -273) translate(352 239) translate(1101 34.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 13,
    r: 12.5,
    fill: "#EDF4FF",
    strokeWidth: 1.087
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006DC9",
    fillRule: "nonzero",
    strokeWidth: 0.6,
    d: "M7.509 10.521c-.134.134-.209.315-.209.503 0 .19.075.37.209.504l4.834 4.838c.133.133.314.208.503.208s.37-.075.503-.208l4.834-4.838c.18-.18.25-.443.183-.69-.067-.245-.26-.437-.506-.502-.246-.066-.508.005-.688.186l-4.331 4.335-4.331-4.335c-.134-.134-.315-.209-.503-.209-.126 0-.292.07-.498.208z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseArrowDown);
export default __webpack_public_path__ + "static/media/collapse-arrow-down.3cb6f9a71924197ba035249cf2b5bfaf.svg";
export { ForwardRef as ReactComponent };